define('app/factories/question_ask_factory',['app/setup', 'app/views/question_ask_view', 'app/models/question'],
  function(takhfifan, questionAskView, question) {
    var question = new takhfifan.Question();

    $('.tkh-question-ask').each(function(){
      var $this = $(this);
      new takhfifan.QuestionAskView({ el: $this, model: question });
    });
});

